<template>
  <div>
    <div class="bg-body-light">
      <div class="content content-full">
        <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center">
          <h1 class="flex-sm-fill font-size-h2 font-w400 mt-2 mb-0 mb-sm-2">{{ $t('home.dashboard.hello') }}</h1>
          <nav class="flex-sm-00-auto ml-sm-3" aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li v-text="selectedChain" class="breadcrumb-item text-uppercase"></li>
              <li class="breadcrumb-item active" aria-current="page">{{ $t('home.dashboard.mainnet') }}</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <stats/>
  </div>
</template>

<script>
import Stats from '@/components/home/stats'

export default {
  name: 'dashboard',
  components: {
    Stats
  },
  computed: {
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  }
}
</script>
